/* import __COLOCATED_TEMPLATE__ from './automation-email-settings.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import templateOnlyComponent from '@ember/component/template-only';
import type AutomationEmailSettings from 'embercom/models/automation-email-settings';

interface Args {
  automationEmailSettings: AutomationEmailSettings;
  body: any;
}

interface Signature {
  Args: Args;
}

const AutomationEmailSettingsComponent = templateOnlyComponent<Signature>();
export default AutomationEmailSettingsComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Operator::AutomationEmailSettings': typeof AutomationEmailSettingsComponent;
    'operator/automation-email-settings': typeof AutomationEmailSettingsComponent;
  }
}
